import { Button, Flex, Modal, Text } from "@/atoms"
import { TICKET_MODAL_Z_INDEX } from "@/const/ticketing.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { TicketingSystemOption } from "@/molecules/TicketingSystemLogo"

import styles from "./TicketSystemPickerModal.module.scss"

import type { TicketSystemPickerModalProps } from "./TicketSystemPickerModal.types"

export const TicketSystemPickerModal = (
  props: TicketSystemPickerModalProps
) => {
  const { open, systems, onSelect, onCancel } = props
  const { t } = useTranslation("translation", { keyPrefix: "ticketing.picker" })

  return (
    <Modal
      destroyOnHidden
      centered
      zIndex={TICKET_MODAL_Z_INDEX}
      open={open}
      title={t("title")}
      footer={null}
      onCancel={onCancel}
    >
      <Flex vertical gap={8}>
        <Text type="secondary">{t("description")}</Text>
        {systems.map((system) => (
          <Button
            key={system}
            block
            className={styles.option}
            onClick={() => onSelect(system)}
          >
            <TicketingSystemOption system={system} />
          </Button>
        ))}
      </Flex>
    </Modal>
  )
}
